export type AttributionParams = {
  utmSource: string | null
  utmMedium: string | null
  utmCampaign: string | null
  utmContent: string | null
  utmTerm: string | null
  fbclid: string | null
  gclid: string | null
  referrer: string | null
}

export const normalizeAttributionParam = (value: string | null | undefined) => {
  if (!value) return null
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function captureAttributionParams(
  searchParams: URLSearchParams,
  referrer?: string | null,
): AttributionParams {
  const fallbackReferrer =
    referrer === undefined
      ? typeof document !== 'undefined'
        ? document.referrer
        : null
      : referrer

  return {
    utmSource: normalizeAttributionParam(searchParams.get('utm_source')),
    utmMedium: normalizeAttributionParam(searchParams.get('utm_medium')),
    utmCampaign: normalizeAttributionParam(searchParams.get('utm_campaign')),
    utmContent: normalizeAttributionParam(searchParams.get('utm_content')),
    utmTerm: normalizeAttributionParam(searchParams.get('utm_term')),
    fbclid: normalizeAttributionParam(searchParams.get('fbclid')),
    gclid: normalizeAttributionParam(searchParams.get('gclid')),
    referrer: normalizeAttributionParam(fallbackReferrer),
  }
}
